import React from 'react'

import { Flex } from '@chatterbug/aaron'

import AboutMe from '../AboutMe/AboutMe'
import RecentDiscussions from '../RecentDiscussions/RecentDiscussions'
import { CommunitySectionType } from '../../types/index'

type Props = {
  login: string
  isCurrentUser: boolean
  community?: CommunitySectionType
}

const Community: React.FC<Props> = ({ login, isCurrentUser, community }) => {
  const { aboutMe, recentDiscussions } = community
  return (
    <Flex
      flexDirection="column"
      alignItems="flex-start"
      width={{ _: '100%', mobile: 'auto' }}
    >
      {aboutMe && (
        <AboutMe
          login={login}
          isCurrentUser={isCurrentUser}
          aboutMe={aboutMe}
        />
      )}
      {recentDiscussions?.length > 0 && (
        <RecentDiscussions recentDiscussions={recentDiscussions} />
      )}
    </Flex>
  )
}

export default Community
